import { commandBrand } from "../branding/brand";
import { useState, useEffect } from "react";
import { Moon, Sun } from "lucide-react";
import { Button } from "@cloch-ai/ui";

/**
 * Theme Toggle - Dark/Light mode switch
 * Persists preference to localStorage
 */
export function ThemeToggle() {
  const [isDark, setIsDark] = useState(() => {
    if (typeof window !== "undefined") {
      const stored = localStorage.getItem("agents-theme");
      if (stored) {
        return stored === "dark";
      }
      // Default is dark (no .light class means dark mode)
      return document.documentElement.classList.contains("light")
        ? false
        : commandBrand.theme === "dark";
    }
    return commandBrand.theme === "dark";
  });

  useEffect(() => {
    // UI library uses :root for dark (default) and .light for light mode
    // Also keep .dark for chat-specific CSS variables
    if (isDark) {
      document.documentElement.classList.remove("light");
      document.documentElement.classList.add("dark");
      localStorage.setItem("agents-theme", "dark");
    } else {
      document.documentElement.classList.add("light");
      document.documentElement.classList.remove("dark");
      localStorage.setItem("agents-theme", "light");
    }
  }, [isDark]);

  return (
    <Button
      variant="ghost"
      size="icon-sm"
      onClick={() => setIsDark(!isDark)}
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
    >
      {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </Button>
  );
}
